Topic = function(data) {
    var self = this;

    var props = [
        {name: 'title', save: true},
        {name: 'excerpt'},
        {name: 'content', save: true},
        {name: 'likes_count', save: true,  data_type: 'int'},
        {name: 'comments_count', save: true, data_type: 'int'},
        {name: 'MAX_UPLOAD_SIZE', save: true},
        {name: 'post_type', save: true, default: 'text'},
        {name: 'video_url', save: true},
        {name: 'board_id', save: true},
        {name: 'board_type', save: true},
        {name: 'video_id', save: true},
        {name: 'newCommentInput', save: true},
        {name: 'created_at', save: true},
        {name: 'updated_at', save: true},
        {name: 'release_date', save: true},
        {name: 'board_name', save: true},
        {name: 'master_board_name', save: true},
        {name: 'slug', save: true},
        {name: 'closed', save: true, data_type: 'boolean'},
        {name: 'liked_by_me', save: true, data_type: 'boolean'},
        {name: 'post_id'},
        {name: 'answered', save: true, data_type: 'boolean'},
        {name: 'sticky', save: true, data_type: 'boolean'},
        {name: 'avatar', save: true},
        {name: 'favorited', save: true, data_type: 'boolean'},
        {name: 'attachments', data_type: 'array', save: true},
        {name: 'newly_created', data_type: 'boolean', default: false},
        {name: 'unread', data_type: 'boolean'},
        {name: 'ticket_status', save: true},
        {name: 'notifications', data_type: 'boolean', default: false},
        {name: 'permissions', data_type: 'array'},
        {name: 'challenge', default: false},
        {name: 'meta_title'},
        {name: 'meta_description'},
        {name: 'views'},
        {name: 'last_commenter'},
        {name: 'named_user'},
        {name: 'named_user_avatar'},
        {name: 'status'},
        {name: 'quiz_id'},
        {name: 'group', data_type: 'object'},
        {name: 'event', data_type: 'object'},
    ];

    self.activeDataRelations = [
        {type: 'hasMany', storeTarget: 'comments', key: 'conversation_id', storage: 'comments'},
        {type: 'hasMany', storeTarget: 'likes', key: 'conversation_id', storage: 'likes'},
        {type: 'belongsTo', storeTarget: 'users', key: 'user_id', storage: 'user'},
        {type: 'belongsTo', storeTarget: 'boards', key: 'board_id', storage: 'board'},
        {type: 'belongsTo', storeTarget: 'subboards', key: 'board_id', storage: 'subboard'}
    ];

    //permissions hotfix
    self.activeDataCustomSetup = function(data) {
        /*
        var object_props = [
            {name: 'delete_topic', default: false},
            {name: 'edit_topic', default: false},
            {name: 'make_sticky', default: false},
            {name: 'read_topic', default: false},
            {name: 'reply_topic', default: false},
            {name: 'view_challenge', default: false},
        ];

        _.each(object_props, function(prop) {
            if(typeof(data.permissions[prop.name]) === 'undefined') {
                self.permissions[prop.name] = prop.default; //set default
            }
        });
        */
    };

    ActiveData.call( self, data); //javascript 'classes' workaround
    self.activeDataInit(self, data, props); //setup active data
};
